<div class="row p-b-10">
    <div class="col-sm-12">
        <h4 id="ct-search-heading" class="page-title">{{TR "Geräte suchen"}}</h4>
    </div>
</div>

<div class="row">
    <div class="col-sm-12">
        <div class="card-box clearfix">
            <div class="row">
                <div class="col-xs-12">
                    <div id="device-filter">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="device-table">
</div>
